module.exports = __webpack_public_path__ + "static/water_glacier12-e88aec051dafe334fdd30a505784ea2a.jpg";